import { render } from "./FleetTrips.vue?vue&type=template&id=381317be&scoped=true"
import script from "./FleetTrips.vue?vue&type=script&lang=js"
export * from "./FleetTrips.vue?vue&type=script&lang=js"

import "./FleetTrips.vue?vue&type=style&index=0&id=381317be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381317be"]])

export default __exports__